import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useRedeemWizard } from '../../hooks/redeem/useRedeemWizard';
import RedeemService from '../../services/redeem.service';
import Step1Coupon from './steps/Step1Coupon';
import Step2Email from './steps/Step2Email';
import Step2bChannel from './steps/Step2bChannel';
import Step3Integrations from './steps/Step3Integrations';
import Step4Preview from './steps/Step4Preview';
import logo from '../../assets/Logo.webp';
import logoText from '../../assets/logo-text-only.webp';

const STEPS = [
  { label: 'Cupon' },
  { label: 'Email' },
  { label: 'Canal' },
  { label: 'Integraciones' },
  { label: 'Preview' },
];

const spinKeyframes = `
@keyframes orbit {
  from { transform: rotate(0deg) translateX(28px) rotate(0deg); }
  to   { transform: rotate(360deg) translateX(28px) rotate(-360deg); }
}
@keyframes spin-arc {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
`;

const styles = {
  shell: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 16px',
    background: 'radial-gradient(ellipse at 50% 0%, #1e0a3c 0%, #09090f 60%)',
  },
  card: {
    width: '100%',
    maxWidth: 520,
    borderRadius: 20,
    border: '1px solid rgba(255,255,255,0.12)',
    background: 'rgba(10,10,20,0.85)',
    backdropFilter: 'blur(12px)',
    padding: '36px 40px',
  },
  brandContainer: {
    textAlign: 'center',
    marginBottom: 32,
    width: '100%',
    maxWidth: 520,
  },
  logoWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 12,
  },
  logoImg: {
    height: 40,
    width: 'auto',
  },
  logoTextImg: {
    height: 22,
    width: 'auto',
  },
  pageTitle: {
    marginTop: 16,
    fontSize: 20,
    fontWeight: 700,
    background: 'linear-gradient(135deg, #a78bfa, #7c3aed)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  stepper: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 28,
  },
  stepperLine: {
    position: 'absolute',
    top: 28,
    left: 28,
    right: 28,
    height: 1,
    transform: 'translateY(-50%)',
    zIndex: 0,
    pointerEvents: 'none',
  },
};

function stepLabelStyle(isDone, isActive) {
  return {
    fontSize: 10,
    textAlign: 'center',
    marginTop: 10,
    transition: 'color 0.3s',
    color: isDone ? '#7c3aed' : isActive ? '#a78bfa' : '#3a3a5c',
  };
}

function StepDot({ isDone, isActive, number }) {
  if (isDone) {
    return (
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56 }}>
        <div style={{ position: 'absolute', width: 56, height: 56, borderRadius: '50%', border: '1px solid rgba(124,58,237,0.2)', background: 'rgba(124,58,237,0.06)' }} />
        <div style={{ width: 30, height: 30, borderRadius: '50%', background: '#7c3aed', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: 13, boxShadow: '0 0 10px rgba(124,58,237,0.5)' }}>✓</div>
      </div>
    );
  }
  if (isActive) {
    return (
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56 }}>
        {/* efecto 1 — arco girando */}
        <div style={{
          position: 'absolute', width: 56, height: 56, borderRadius: '50%',
          background: 'conic-gradient(from 0deg, #7c3aed 0deg, #a78bfa 90deg, transparent 120deg, transparent 360deg)',
          animation: 'spin-arc 1.4s linear infinite',
        }} />
        <div style={{ position: 'absolute', width: 48, height: 48, borderRadius: '50%', background: 'rgba(10,10,20,0.92)' }} />
        <div style={{ position: 'absolute', width: 40, height: 40, borderRadius: '50%', border: '1px solid rgba(124,58,237,0.35)', background: 'rgba(124,58,237,0.05)' }} />
        <div style={{ width: 14, height: 14, borderRadius: '50%', background: '#ede9fe', boxShadow: '0 0 6px #c4b5fd, 0 0 18px rgba(124,58,237,0.7), 0 0 34px rgba(124,58,237,0.3)', zIndex: 1 }} />
      </div>
    );
    /* efecto 3 — punto orbitando (descomentar para activar)
    return (
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56 }}>
        <div style={{
          position: 'absolute', width: 6, height: 6, borderRadius: '50%',
          background: '#a78bfa', boxShadow: '0 0 6px #a78bfa, 0 0 14px rgba(124,58,237,0.8)',
          animation: 'orbit 1.6s linear infinite',
        }} />
        <div style={{ position: 'absolute', width: 56, height: 56, borderRadius: '50%', border: '1px solid rgba(124,58,237,0.2)' }} />
        <div style={{ position: 'absolute', width: 40, height: 40, borderRadius: '50%', border: '1px solid rgba(124,58,237,0.35)', background: 'rgba(124,58,237,0.05)' }} />
        <div style={{ width: 14, height: 14, borderRadius: '50%', background: '#ede9fe', boxShadow: '0 0 6px #c4b5fd, 0 0 18px rgba(124,58,237,0.7), 0 0 34px rgba(124,58,237,0.3)', zIndex: 1 }} />
      </div>
    );
    */
  }
  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56 }}>
      <div style={{ position: 'absolute', width: 56, height: 56, borderRadius: '50%', border: '1px dashed rgba(40,28,70,0.22)' }} />
      <div style={{ position: 'absolute', width: 40, height: 40, borderRadius: '50%', border: '1px solid rgba(30,20,55,0.3)' }} />
      <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#0e0e1c', border: '1px solid #252540', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#3a3a5c', fontSize: 11, fontWeight: 700 }}>{number}</div>
    </div>
  );
}

export default function RedeemView() {
  const wizard = useRedeemWizard();
  const [searchParams, setSearchParams] = useSearchParams();

  // Al montar: si viene ?code= y el wizard no tiene código, prellenarlo (deep-link).
  useEffect(() => {
    const codeParam = searchParams.get('code');
    if (codeParam && !wizard.couponCode) {
      wizard.setCouponCode(codeParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Al montar: si venimos de la verificación de correo (?verified=1), avanzar al
  // paso de elegir canal. El enlace del correo se abre en cualquier pestaña, así
  // que si el estado local está vacío reconstruimos el template desde el ?code=.
  useEffect(() => {
    if (searchParams.get('verified') !== '1') return;
    const codeParam = searchParams.get('code') || wizard.couponCode || '';
    (async () => {
      wizard.setEmailVerified(true);
      if (!wizard.templateData && codeParam) {
        try {
          const data = await RedeemService.previewCoupon(codeParam);
          wizard.setCouponCode(codeParam);
          wizard.setTemplateData(data);
        } catch (_) { /* si el preview falla, igual avanzamos con lo que haya */ }
      }
      // El enlace de verificación puede abrirse en OTRA pestaña, cuyo sessionStorage
      // (donde vive el estado del wizard) está vacío. Reconstruir companyName y
      // account_id desde localStorage (que Step2Email guardó y SÍ cruza pestañas),
      // para que el Preview muestre la empresa y las integraciones encuentren la cuenta.
      try {
        // Keys propias del redeem (OrganizationContext no las toca), con fallback legacy.
        let storedAccountId = localStorage.getItem('redeem_account_id');
        let storedName = localStorage.getItem('redeem_company_name');
        if (!storedAccountId || !storedName) {
          const storedMeta = JSON.parse(localStorage.getItem('currentAccountMeta') || '{}');
          storedAccountId = storedAccountId || storedMeta?.id || localStorage.getItem('currentAccountId');
          storedName = storedName || storedMeta?.name;
        }
        if (!wizard.companyName && storedName) {
          wizard.setCompanyName(storedName);
        }
        if (!wizard.redemptionData?.account_id && storedAccountId) {
          let workflowIds = wizard.redemptionData?.workflow_ids;
          if (!workflowIds) {
            try { workflowIds = JSON.parse(localStorage.getItem('redeem_workflow_ids') || 'null'); } catch (_) { /* ignore */ }
          }
          wizard.setRedemptionData({
            ...(wizard.redemptionData || {}),
            account_id: storedAccountId,
            organization_id: wizard.redemptionData?.organization_id
              || localStorage.getItem('redeem_organization_id') || undefined,
            workflow_ids: workflowIds || undefined,
          });
        }
      } catch (_) { /* localStorage corrupto: ignorar */ }
      wizard.goToStep(3);
      // Consumir el flag de la URL para que un refresh no re-dispare el avance.
      const next = codeParam ? { code: codeParam } : {};
      setSearchParams(next, { replace: true });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Si el enlace de verificación se abre en OTRA pestaña, esta pestaña (la
  // original del redeem) se entera por el evento `storage` de localStorage
  // (que sí cruza pestañas del mismo navegador) y avanza al paso de canal.
  useEffect(() => {
    function onStorage(e) {
      if (e.key === 'redeem_email_verified' && e.newValue) {
        wizard.setEmailVerified(true);
        if (wizard.step < 3) wizard.goToStep(3);
      }
    }
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizard.step]);

  // Reflejar el código del wizard en la URL para deep-link / restauración.
  useEffect(() => {
    if (wizard.couponCode && searchParams.get('code') !== wizard.couponCode) {
      setSearchParams({ code: wizard.couponCode }, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizard.couponCode]);

  return (
    <div style={styles.shell}>
      <style>{spinKeyframes}</style>
      <div style={styles.brandContainer}>
        <div style={styles.logoWrapper}>
          <img src={logo} alt="Zenit AI Logo" style={styles.logoImg} />
          <img src={logoText} alt="Zenit AI" style={styles.logoTextImg} />
        </div>
      </div>

      <div style={styles.card}>
        {/* Stepper */}
        <div style={styles.stepper}>
          {/* Background line */}
          <div style={styles.stepperLine}>
            <div style={{ position: 'absolute', left: 0, width: `${((wizard.step - 1) / (STEPS.length - 1)) * 100}%`, height: 1, background: '#7c3aed', transition: 'width 0.3s' }} />
            <div style={{ position: 'absolute', left: 0, right: 0, height: 1, background: '#1e1e35', zIndex: -1 }} />
          </div>

          {STEPS.map((s, i) => {
            const isDone = i + 1 < wizard.step;
            const isActive = i + 1 === wizard.step;
            return (
              <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', zIndex: 1 }}>
                <StepDot isDone={isDone} isActive={isActive} number={i + 1} />
                <div style={stepLabelStyle(isDone, isActive)}>{s.label}</div>
              </div>
            );
          })}
        </div>

        {/* Step content */}
        {wizard.step === 1 && <Step1Coupon wizard={wizard} />}
        {wizard.step === 2 && <Step2Email wizard={wizard} />}
        {wizard.step === 3 && <Step2bChannel wizard={wizard} />}
        {wizard.step === 4 && <Step3Integrations wizard={wizard} />}
        {wizard.step === 5 && <Step4Preview wizard={wizard} />}
      </div>
    </div>
  );
}
